import { render, staticRenderFns } from "./UgcReportForm.vue?vue&type=template&id=28f7233d&"
import script from "./UgcReportForm.vue?vue&type=script&lang=ts&"
export * from "./UgcReportForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports